export const upDownArrowAccessibility = (
  classname: string,
  parentClassname?: string
): void => {
  document.onkeydown = (event) => {
    const classes = document.getElementsByClassName(classname);
    const selected = Array.from(classes).indexOf(
      document.querySelector(`.${classname}:focus`)
    );

    let next = selected + 1;
    let pre = selected - 1;
    if (selected === classes.length - 1) next = selected;

    if (pre < 0) pre = 0;
    if (next > classes.length) next = classes.length;

    // up key press
    if (event.code === "ArrowUp") {
      (document.querySelectorAll(`.${classname}`)[pre] as HTMLElement).focus();
    }
    // down key press
    else if (event.code === "ArrowDown") {
      (document.querySelectorAll(`.${classname}`)[next] as HTMLElement).focus();
    }
    // enter key press
    else if (event.code === "Enter" || event.code === "Space") {
      (
        document.querySelectorAll(`.${classname}`)[next - 1] as HTMLElement
      )?.click();
      (
        document.querySelectorAll(`.${parentClassname}`)[0] as HTMLElement
      )?.click();
      clearAccessibilityFn();
    } else {
      if (event.code !== "Tab") clearAccessibilityFn();
    }
  };
};

export const clearAccessibilityFn = (): void => {
  document.onkeydown = null;
};
